export const isMinView = (width = 900) => {
    return window.innerWidth < width;
}

export const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}.${month}.${day} ${hours}:${minutes}`;
}

export const _trackCustomEvent = (event, property) => {
    if (window._hmt !== undefined) {
        window._hmt.push(['_trackCustomEvent', event, property]);
    }
}
export const _trackEvent = (event, property) => {
    if (window._hmt !== undefined) {
        window._hmt.push(['_trackEvent', event, property]);
    }
}

// 客户端地址（通用，默认使用32位安装包）
export const CLIENT_URL = 'https://img2.nanxinwang.com/apps/pc/QiXiuBaoInstV2_x32.exe'
// 客户端地址（32位）
export const CLIENT_URL_X32 = 'https://img2.nanxinwang.com/apps/pc/QiXiuBaoInstV2_x32.exe'
// 客户端地址（64位）
export const CLIENT_URL_X64 = 'https://img2.nanxinwang.com/apps/pc/QiXiuBaoInstV2_x64.exe'
// Windows XP / Server 2003 / XP Embedded 网页端使用的旧版安装包
export const CLIENT_URL_LEGACY = 'https://www.qixiubao.cn/static/QiXiuBaoInst.exe'

// Windows XP、Server 2003、XP Embedded 仍使用旧版安装包
const isLegacyWindows = (ua) => {
    return /Windows NT 5\.[12]/i.test(ua)
        || /Windows XP/i.test(ua)
        || /Windows Server 2003/i.test(ua)
        || /XP Embedded/i.test(ua)
}

// 64 位系统：64 位浏览器，或 32 位浏览器跑在 64 位系统上（WOW64）
const is64BitSystem = (ua, platform, cpuClass) => {
    return /Win64|WOW64|x64|amd64|x86_64|IA64|ARM64/i.test(ua)
        || /Win64|x64|amd64|ARM64/i.test(platform)
        || /x64/i.test(cpuClass)
}

/**
 * 按当前电脑系统返回客户端下载地址
 * XP / Server 2003 / XP Embedded → 旧版安装包
 * 64 位系统 → 64 位安装包
 * 其余（含无法识别）→ 默认 32 位安装包
 */
export const getClientDownloadUrl = () => {
    const nav = typeof navigator !== 'undefined' ? navigator : {}
    const ua = nav.userAgent || ''
    if (isLegacyWindows(ua)) {
        return CLIENT_URL_LEGACY
    }
    if (is64BitSystem(ua, nav.platform || '', nav.cpuClass || '')) {
        return CLIENT_URL_X64
    }
    return CLIENT_URL || CLIENT_URL_X32
}

export const onEventGsIdo = (id, name = '', arr = []) => {
    const attrsArr = [
        ['qxb_name', name],
        ['qxb_date', new Date()],
        ['qxb_frequency', true],
        ...arr
    ]
    if (window.GsIdo !== undefined) {
        window.GsIdo.onEvent({
        //事件id
        id,
        //自定义属性，注意value的类型只能是string|number|Date|boolean
        attrs: new Map(attrsArr)
        });
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js